module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0031.jpg?v=8602fa8a";